import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-user-workingdays-list',
  templateUrl: './user-workingdays-list.component.html',
  styleUrls: ['./user-workingdays-list.component.css']
})
export class UserWorkingdaysListComponent implements OnInit {

  constructor(private userService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  output:any=[]
  alert=""
  ListId=""
  ListName=""
  admin:any=[]
  New_count=0;
  count=0;
  user_Id=null;
  next_output:any=[];
  loaderShown=true;
  cardShown=false;
  getdata: any = [];
  setData: any;
  array: any;
  UserId:any

  btnClick(Id:any){
   // this.router.navigateByUrl(('admin/add-working-days'));  
   this.router.navigate(['admin/user-working-days'],{queryParams:{setData:JSON.stringify({Id})}});
  
  }
//-----------function for set id of deleting user------------
SetAttendence(Id:any){
  this.ListId=Id
}

//---------function for delete a user-----------------------
  DeleteList()
 {
   //-------api delete user-------------
   this.userService.deleteUserWorkingDays(this.ListId).subscribe((res)=>{
   this.alert=res.message
   console.log("Response=",this.ListId)
   this.ngOnInit();
    })
  
 }
  //------function for routing-------------------------
  Details(Id:any){
    this.router.navigate(['admin/user-working-days-view'],{queryParams:{setData:JSON.stringify({Id})}});
  }

  //-----function for urouting to edit user details---------
  EditDetails(Id:any){

    this.router.navigate(['admin/user-working-days-edit'],{queryParams:{setData:JSON.stringify({Id})}});
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }

    //--------------function for date formating-----------------
    formatDate(dateStr: string): any {
      if(dateStr==null)
      return
      const [year, month] = dateStr.split('-');
      const date = new Date(`${year}-${month}-01`);
  
      const formattedDate = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
      return formattedDate;
    }
  ngOnInit(): void {

    this.UserId=this.userService.getUserId()
    this.route.queryParams.subscribe((params) => {
      this.getdata = params;
      this.setData = this.getdata.setData;
      const obj = JSON.parse(this.setData);
      this.array = [obj];
       this.user_Id=this.array[0].Id;
    })


    console.log("this.user_Id",this.user_Id)
    this.userService.viewUserWorkingDays(this.user_Id).subscribe((res)=>{
    this.output=res.data
    this.loaderShown=false;
    this.cardShown=true;
  
    console.log("output=",this.output)

    })

  }

}
